import { NavLink, useLocation } from "react-router-dom";

import style from "../../sass/components/header.module.scss";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import SwitchLang from "../SwitchLang";

const AdminHeader = () => {
    const {t} = useTranslation();
    const [burgerOpened, setBurgerOpened] = useState(false);
    const location = useLocation()

    return (
        <>
            <header
                className="w-full fixed flex justify-between items-center px-14 shadow-2xl"
                style={{
                    height: 60,
                    zIndex: 100,
                    backgroundColor: "white",
                    borderRadius: "0 0 10px 10px",
                    maxWidth: 1366,
                }}
            >
                {/* Left */}
                <div className="flex gap-8">
                    <div className={`${style.logoContainer}`} style={{display: 'block', width: 100, height: 60}}>
                        <NavLink to="/" className={style.logoLink} style={{display: 'block', width: 100, height: 60}}>
                            <img
                                className={style.logo} 
                                src="/static/images/png/pony-express-logo.png" 
                                alt="logo" />
                        </NavLink>
                    </div>
                    <SwitchLang />
                </div>

                {/* Right */}
                <div className="relative">
                    <div className={`${style.wideScreen} w-full flex gap-6`}>
                        <NavLink 
                            className={`
                                text-xs
                                ${style.linkBold} 
                                ${location.pathname === "/calc" ? style.selected : "" }
                            `}
                            to="/calc"
                        >
                            <span>
                                Calc
                            </span>
                        </NavLink>
                        <NavLink 
                            className={`
                                text-xs
                                ${style.linkBold} 
                                ${location.pathname === "/admin/users" ? style.selected : "" }
                            `}
                            to="/admin/users"
                        >
                            <span>
                                Users
                            </span>
                        </NavLink>
                        <NavLink
                            className={`
                                text-xs
                                ${style.linkBold} 
                                ${location.pathname === "/admin/prices" ? style.selected : "" }
                            `}
                            to="/admin/prices"
                        >
                            <span>Prices</span>
                        </NavLink>
                        
                        <NavLink 
                            className={`
                                text-xs
                                ${style.linkBold} 
                                ${location.pathname === "/admin/over-prices" ? style.selected : "" }
                            `}
                            to="/admin/over-prices"
                        >
                            <span>OverPrices</span>
                        </NavLink>
                        <NavLink 
                            className={`
                                text-xs
                                ${style.linkBold} 
                                ${location.pathname === "/profile" ? style.selected : "" }
                            `}
                            to="/profile"
                        >
                            <span>
                                Profile
                            </span>
                        </NavLink>
                    </div>

                    <div
                        className={`${style.burgerMenuButton}`}
                        onClick={() => setBurgerOpened(!burgerOpened)}
                    >
                        <span
                            className={`${style.burgerLine} ${
                                style.burgerLine1
                            } ${burgerOpened ? style.checked : ""}`}
                        ></span>
                        <span
                            className={`${style.burgerLine} ${
                                style.burgerLine2
                            } ${burgerOpened ? style.checked : ""}`}
                        ></span>
                        <span
                            className={`${style.burgerLine} ${
                                style.burgerLine3
                            } ${burgerOpened ? style.checked : ""}`}
                        ></span>
                    </div>
                </div>
            </header>

            {/* Burger menu body */}
            <div
                className={`${style.burgerMenuBody} ${
                    burgerOpened ? style.active : ""
                }`}
            >
                <div
                    className="relative"
                    style={{
                        height: "100%",
                        width: "100%",
                    }}
                >
                    <div
                        className="absolute inset-0 h-fit w-fit m-auto flex flex-col items-start gap-14"
                    >
                        <NavLink
                            className={`${style.linkBold} text-left`}
                            to="/calc"
                            onClick={() => setBurgerOpened(false)}
                        >
                            <span>
                                Calc
                            </span>
                        </NavLink>
                        <NavLink
                            className={`${style.linkBold} text-left`}
                            to="/admin/users"
                            onClick={() => setBurgerOpened(false)}
                        >
                            <span>
                                Users
                            </span>
                        </NavLink>
                        <NavLink
                            className={`${style.linkBold} text-left`}
                            to="/admin/prices"
                            onClick={() => setBurgerOpened(false)}
                        >
                            <span>
                                Prices
                            </span>
                        </NavLink>
                        <NavLink 
                            className={`${style.linkBold} text-left`} 
                            to="/admin/over-prices"
                            onClick={() => setBurgerOpened(false)}
                        >
                            <span>
                                Over prices
                            </span>
                        </NavLink>
                        <NavLink 
                            className={`${style.linkBold} text-left`} 
                            to="/profile"
                            onClick={() => setBurgerOpened(false)}
                        >
                            <span>
                                Profile
                            </span>
                        </NavLink>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AdminHeader;
